/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_EditInputs */

const cs_settings_users_edit = /** @type {(inputs: Settings_Users_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit uživatele`)
};

const en_settings_users_edit = /** @type {(inputs: Settings_Users_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit user`)
};

/**
* | output |
* | --- |
* | "Edit user" |
*
* @param {Settings_Users_EditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_edit = /** @type {((inputs?: Settings_Users_EditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_EditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_edit(inputs)
	return cs_settings_users_edit(inputs)
});